import { useState, useEffect } from 'react';
import { MOBILE_BANNER_DRAWER_HEIGHT, DESKTOP_BANNER_DRAWER_HEIGHT } from '@quickenloans-ui-suite/components/constants';
import { setBannerTimeout, clearBannerTimeout } from '@quickenloans-ui-suite/components/utils';
import { useBottomDrawerCookie } from '../useBottomDrawerCookie';
import getContextualSourceId from '../getContextualSourceId';
import { BOTTOM_DRAWER_DELAY } from './constants';

const voidFn = () => undefined;

const useBottomDrawer = () =>
{
    const { bottomDrawerCookie, setBottomDrawerCookie } = useBottomDrawerCookie();
    const [ showBottomDrawer, setShowBottomDrawer ] = useState( false );
    useEffect( () =>
    {
        const shouldShow = bottomDrawerCookie ? !bottomDrawerCookie.isClosed : true;
        if ( shouldShow )
        {
            setBannerTimeout({
                callback: () => setShowBottomDrawer(true),
                duration: BOTTOM_DRAWER_DELAY
            })
        }
        return shouldShow ? () => clearBannerTimeout( ) : voidFn;
    }, [])

    const sourceId = getContextualSourceId({ suffix: 'bottomdrawer'} );

    const setIsVisible = (vis) =>
    {
        if ( vis ) return;
        setShowBottomDrawer( false );
    }

    const onTransitionEnter = () =>
    {
        setBottomDrawerCookie();
    }

    return {
        isVisible: showBottomDrawer,
        setIsVisible,
        onTransitionEnter,
        onTransitionExited: voidFn,
        onNavigate: () =>setIsVisible(false),
        sourceId,
        bottomDrawerOffset: {
            mobile: showBottomDrawer ? `${MOBILE_BANNER_DRAWER_HEIGHT}px` : '0',
            desktop: showBottomDrawer ? `${DESKTOP_BANNER_DRAWER_HEIGHT}px` : '0',
        }
    }

}

export default useBottomDrawer;
